import React from "react";
import Footer from "../components/Footer";
import Cta from "../components/Cta";
import { Variants } from "framer-motion";
import ApplyForm from "../components/ApplyForm";
import Hero from "../components/Heros/HeroRecruit";
const cardVariants: Variants = {
    offscreen: {
        x: -500
    },
    onscreen: {
        x: 0,
        transition: {
            type: "spring",
            bounce: 0.4,
            duration: 0.8
        }
    }
};
const RecruitApply = () => (
    <>
        <Hero />
        <ApplyForm />
        <Cta preset="recruit" />
        <Footer />
    </>
);

export default RecruitApply;
